document.addEventListener("DOMContentLoaded", function () {
  var cloudButton = document.querySelector(".cloud");
  var onPremiseButton = document.querySelector(".onPremise");
  var cloudContainer = document.querySelector(".cloud-hosting");
  var onPremiseContainer = document.querySelector(".onpremise-hosting");

  cloudButton.addEventListener("click", function () {
    if (cloudButton.classList.contains("bg-neutral-silver")) {
      cloudButton.classList.remove("bg-neutral-silver");
      cloudButton.classList.add("bg-neutral-ghost");
      onPremiseButton.classList.remove("bg-neutral-ghost");
      onPremiseButton.classList.add("bg-neutral-silver");
      onPremiseContainer.classList.remove("grid");
      onPremiseContainer.classList.add("hidden");
      cloudContainer.classList.remove("hidden");
      cloudContainer.classList.add("grid");
    }
  });

  onPremiseButton.addEventListener("click", function () {
    if (onPremiseButton.classList.contains("bg-neutral-silver")) {
      onPremiseButton.classList.remove("bg-neutral-silver");
      onPremiseButton.classList.add("bg-neutral-ghost");
      cloudButton.classList.remove("bg-neutral-ghost");
      cloudButton.classList.add("bg-neutral-silver");
      cloudContainer.classList.remove("grid");
      cloudContainer.classList.add("hidden");
      onPremiseContainer.classList.remove("hidden");
      onPremiseContainer.classList.add("grid");
    }
  });
});
